var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('answer-sheet-layout'),_c('div',{staticClass:"main-info"},[_c('answer-sheet-set'),_c('answer-sheet-content',{ref:"answerContent"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }